import React, { Component } from 'react';
import Header from 'parts/Header';
import CompanyCharterHero from 'parts/CompanyCharterHero';
import CompanyCharterContent from 'parts/CompanyCharterContent';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

export default class CompanyCharterPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <CompanyCharterHero />
        <CompanyCharterContent />
        <Discuss />
        <Footer />
      </>
    );
  }
}
